import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InscriptionService } from 'app/service/inscription.service';
import { MatTableDataSource } from '@angular/material/table';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-paiement-historique',
  templateUrl: './paiement-historique.component.html',
  styleUrls: ['./paiement-historique.component.css']
})
export class PaiementHistoriqueComponent implements OnInit {

  @Output() refreshData: EventEmitter<any> = new EventEmitter();
  @ViewChild('modalPaiementHistorique') modalPaiementHistoriqueContent: string;
  public displayedColumns = ['date', 'statut', 'type', 'montant', 'observations', 'action'];
  public dataSource: MatTableDataSource<any>;
  public inscription: any;

  constructor(
    private modalService: NgbModal,
    private inscriptionService: InscriptionService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
  ) { }

  async ngOnInit() {
  } // fin ngOnInit

  async open(data) {
    this.inscription = data;
    const paiements: any = await this.inscriptionService.getPaiementsByNumero(data).toPromise();
    this.dataSource = new MatTableDataSource(paiements);
    this.modalService
      .open(this.modalPaiementHistoriqueContent, { ariaLabelledBy: "modal-basic-title", size: 'lg', scrollable: true })
      /*.shown.subscribe(() => {
      })*/
  } // fin open

  closeModal() {
    this.modalService.dismissAll();
  } // fin closeModal

  cancelPaiement(data) {
    const dataSend = {
      _id: data._id
    };
    Swal.fire({
      title: "Êtes-vous sûr d'annuler ce paiement ?",
      text: 'Attention, si deux inscriptions sont associées à ce paiement, les deux ne seront plus valide!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non'
    }).then((result1) => {
      if (result1.value) {
        this.spinner.show();
        this.inscriptionService.cancelPaiement(dataSend).subscribe((response: any) => {
          if (response === 'Successfully canceled') {
            this.spinner.hide();
            this.toastr.success('Paiement annulé avec succès');
            this.refreshData.next();
            this.closeModal();
          } else {
            this.spinner.hide();
            this.toastr.warning('Le serveur a rencontré un problème');
          }
        });
      } else if (result1.dismiss === Swal.DismissReason.cancel) {
        this.toastr.warning('Votre action sera annulée');
      }
    });
  } // fin cancelPaiement

}


